/**
 * Date utility functions
 */

/**
 * Format a date string to a readable format
 * @param {string} dateString - ISO date string (e.g., "2026-10-30")
 * @returns {string} - Formatted date (e.g., "Oct 30, 2026")
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

